import React, { useEffect, useState } from 'react';

const KAKAO_SRC = 'https://dapi.kakao.com/v2/maps/sdk.js?appkey=2f792e91b4c8873c68185f5228568ad5&autoload=false&libraries=services,drawing';

interface Context {
  kakaoLoaded: boolean;
}

export const ScriptLoaderContext = React.createContext<Context>({ kakaoLoaded: false });

export const ScriptLoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [kakaoLoaded, setKakaoLoaded] = useState<boolean>(false);

  useEffect(() => {
    loadScript(KAKAO_SRC, () => {
      window.kakao?.maps.load(() => {
        setKakaoLoaded(true);
      });
    });
  }, []);

  return <ScriptLoaderContext.Provider value={{ kakaoLoaded }}>{children}</ScriptLoaderContext.Provider>;
};

function loadScript(url: string, onLoad: () => void) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.onload = onLoad;
  script.src = url;
  document.head.appendChild(script);
}
